const ADD_SYS_MESSAGE = 'ADD_SYS_MESSAGE';
const REMOVE_SYS_MESSAGE = 'REMOVE_SYS_MESSAGE';

export { ADD_SYS_MESSAGE, REMOVE_SYS_MESSAGE };
